"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableStyle = void 0;
var tslib_1 = require("tslib");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var style_base_1 = require("../../style-base");
var TableStyle = (function (_super) {
    tslib_1.__extends(TableStyle, _super);
    function TableStyle(styleName, localizedName, deleted, hidden, semihidden, isDefault, conditionalStyles, baseConditionalStyle, base64EncodedImage, id) {
        var _this = _super.call(this, styleName, localizedName, deleted, hidden, semihidden, isDefault, base64EncodedImage, id) || this;
        _this.conditionalStyles = {};
        _this.conditionalStyles = conditionalStyles;
        _this.baseConditionalStyle = baseConditionalStyle;
        return _this;
    }
    TableStyle.prototype.clone = function () {
        var newStyle = new TableStyle(this.styleName, this.localizedName, this.deleted, this.hidden, this.semihidden, this.isDefault, number_1.NumberMapUtils.map(this.conditionalStyles, function (cs) { return cs.clone(); }), this.baseConditionalStyle.clone(), this.base64EncodedImage, this.id);
        return newStyle;
    };
    TableStyle.SIMPLE_STYLENAME = "Table Simple 1";
    TableStyle.DEFAULT_STYLENAME = "Normal Table";
    TableStyle.DEFAULT_STYLENAME_2 = "Table Normal";
    return TableStyle;
}(style_base_1.StyleBase));
exports.TableStyle = TableStyle;
